module.exports = __webpack_public_path__ + "img/image-express.56c99f60.jpg";